import {
	TTableStructure,
	ETableStructureType,
	ETableStructureAlign,
	TTableStructureButton,
} from '../../../../../ui/EasTable/types';
import { EIconButtons } from '../../../../../ui/EasTable/EasTableRow/EasTableValue/constants';

export type TEmAttachmentVersion = {
	id: number;
	attachedBy: {
		id: string;
		email: string;
		fullName: string;
	};
	comment: string | null;
	createdAt: string;
};

export type TEmAttachmentsRow = {
	id: number;
	fileName: string;
	type: string;
	typeId: number;
	isDownloadAllowed: boolean;
	isDeleteAllowed: boolean;
	versions: TEmAttachmentVersion[];
};

export const tableStructure: TTableStructure<keyof TEmAttachmentsRow, TEmAttachmentsRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Created at',
		selector: 'versions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
		value: (item: TEmAttachmentsRow) => item?.versions?.[0]?.createdAt ?? '',
	},

	{
		name: 'File name',
		selector: 'fileName',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		searchable: true,
	},
	{
		name: 'Type',
		selector: 'type',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Comment',
		selector: 'versions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		value: (item: TEmAttachmentsRow) => item?.versions?.[0]?.comment ?? '',
	},
	{
		name: 'Attached by',
		selector: 'versions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		value: (item: TEmAttachmentsRow) => (item?.versions?.[0]?.attachedBy ?? null) as any,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [
			{ name: 'Download', icon: EIconButtons.DOWNLOAD },
			{ name: 'Delete', icon: EIconButtons.DELETE },
		],
		buttonFilter: (item: TEmAttachmentsRow) => {
			const buttons = [] as TTableStructureButton[];
			if (item.isDownloadAllowed) buttons.push({ name: 'Download', icon: EIconButtons.DOWNLOAD });
			if (item.isDeleteAllowed)
				buttons.push({ name: 'Delete', icon: EIconButtons.DELETE, color: 'error.main' });
			return buttons;
		},
	},
];
